import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import PricingSection from '../components/PricingSection';
import ResellersSection from '../components/ResellersSection';
import BackToOverview from '../components/BackToOverview';

const PricingPage: React.FC = () => {
  useRouteMeta('pricing');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.pricing.eyebrow}
        title={r.routes.pricing.heroTitle}
        subtitle={r.routes.pricing.heroSubtitle}
      />
      <PricingSection />
      <ResellersSection />
      <BackToOverview />
    </>
  );
};

export default PricingPage;
